import Feature from './Feature'

class IntegerValueFeature extends Feature {
  constructor(featureData, i18n) {
    super(featureData, i18n)
    const parsedNumber = Number.parseInt(featureData.value, 10)
    if (!Number.isNaN(parsedNumber)) {
      this._value = parsedNumber
    } else {
      throw new Error(
        `Cannot parse value ${featureData.value} to a valid Integer`
      )
    }
  }
}
export default IntegerValueFeature
